<template>
  <div class='login'>
    <div class="HomeHeader">
      <a-row class="top">
        <a-col :span="10">
          <img src="@assets/img/logo.png" @click="router.push({
            name : 'home'
          })"/>
        </a-col>
        <a-col :span="14">


        </a-col>  
      </a-row>
      
    </div>
  
    <div class='login_cont'>

        <div class='limit'>
          <div class='code_content'>
            <img src='@assets/img/code.png' class='img'>
            <div>
              <div>扫描二维码</div>
              <div>随时下单更方便、快捷</div>
              <div>商务专享 极致体验 !!!</div>
            </div>
          </div>

          <img src='@assets/img/plane.png' class='plane'>

          

          <div class='login_form'>
            <h3 class='title'>账号登录</h3>
            <a-form
              :ref="ruleForm"
              :model="form"
              :rules="rules"
            > 
              <a-form-item ref="name" name="name">
                <a-input v-model:value="form.name" placeholder="账号/手机号"/>
              </a-form-item>

              <a-form-item ref="name" name="password">
                <a-input v-model:value="form.password" placeholder="登录密码" type='password'/>
              </a-form-item>
              <a-button type="primary" class='submitBtn' @click='submit' :loading='isLoginCheck'>
                  登 录
              </a-button>
              <div class='login_tips'>登录即代表您同意我们的 服务协议 和 隐私策略</div>
            </a-form>
          </div>

        </div>
    </div>
  </div>
</template>
<script>
  import commonApi from '@axios/common'
  import { ref } from "vue";
  import { useRouter } from "vue-router";
  import { message } from 'ant-design-vue';
  import { useStore } from 'vuex'
  export default {
    name: 'login',
    components: {
      
    },
    setup(){
      const router = useRouter();
      let isLoginCheck = ref(false);
      const store = useStore();

      const submit = () => {

        refsItem[0].validate().then(()=>{
          let params = {
            account : form.value.name,
            password : form.value.password,
          }
          isLoginCheck.value = true
          commonApi.login(params).then((res)=>{
              isLoginCheck.value = false
              //存储store
              store.commit('setToken',res.authorization);
              store.commit('setUserName',res.displayName);
              store.commit('setDistributorId',res.id);
              store.commit('setMobile',res.mobile);
              
                
              let pathName = sessionStorage.getItem('url') || 'home'
              let pathq = sessionStorage.getItem('urlq') || '{}'
              
              router.replace({ name: pathName ,query:JSON.parse(pathq)})
          }).catch(()=>{
            isLoginCheck.value = false
          })       
        })
      }

      let form = ref({
        name : '',
        password : ''
      })

      let refsItem = [];

      const ruleForm = (el) => {
        refsItem.push(el)
      }

      return {
        router,
        ruleForm,
        form,
        submit,
        isLoginCheck,
    
        rules : {
          name: [
              { required: true, message: '请输入用户名', trigger: 'blur' }
          ],
          password: [
              { required: true, message: '请输入密码', trigger: 'blur' }
          ],
        }
      }

    },
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .code_content{
    position: absolute;
    left: 30px;
    top:40px;
    display: flex;
    justify-content: flex-start;
    &>div{
      margin-left: 15px;

      font-size: 22px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #FFFFFF;
      line-height: 30px;
      letter-spacing: 1px;

    }
 
    img{
      width: 100px;
      height: 100px;

    }
  }
  .plane{
    width: 882px;
    position: absolute;
    left: -50px;
    top: 202px;
  }
  .submitBtn{
    background:#FFAB00;
    border-color: #FFAB00;
    width: 100%;
    height: 40px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 40px;
    margin-top: 15px;
  }
  .login_tips{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #BBBBBB;
    margin-top: 13px;
    margin-bottom:80px;
  }
  .login{
    display: flex;
    flex-direction: column;
  }
  .login_cont{
    background: #409EFF;
    min-height: 480px;
    flex: 1;
    display: flex;
    flex-direction: column;
    
    .limit{
      flex: 1;
      width: 1200px;
      margin: 0 auto;
      position: relative;
  
    }
    .login_form{
      background: #fff;
      border-radius: 4px;
      width: 380px;
      padding: 28px 30px;
      position: absolute;
      right:0;
      top:40px;
      .title{
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color:#000000;
        margin-bottom: 22px;
      }
    }
  }


  .limit {
    ::v-deep(.ant-input){
      height: 40px;
    }

    ::v-deep(.ant-form-item){
      margin-bottom: 17px;
    }
  } 



  .icon{
    margin-left:10px;
  }
  .top {
    width: 1200px;
    height: 90px;
    line-height: 90px;
    margin: 0 auto;
    .ant-col-10 {
      text-align: left;
      img {
        height: 68px;
        cursor: pointer;
      }
    }
    .ant-col-14 {
      text-align: right;
      color: #6d7278;
      .action {
        color: #0D6DBF;
        margin: 0 4px;
      }
      span {
        color: #0d6dbf;
        margin-left: 6px;
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
  .nav {
    width: 100%;
    height: 40px;
    background: #409EFF;
    color: #ffffff;
    .main {
      width: 1200px;
      height: 40px;
      line-height: 40px;
      margin: 0 auto;
      .ant-col-14 {
        text-align: left;
        span {
          display: inline-block;
          width: 65px;
          height: 40px;
          text-align: center;
          cursor: pointer;
        }
        .train {
          background: #0D6DBF;
          position: relative;
          span{
            display: block;
            width: 0;
            height: 0;
            border: 7.5px solid #fff;
            position: absolute;
            bottom: 0;
            left:50%;
            margin-left: -7.5px;
            border-right:7.5px solid transparent;
            border-top:7.5px solid transparent;
            border-left:7.5px solid transparent;
          }
        }
      }
      .ant-col-10 {
        text-align: right;
        span {
          cursor: pointer;
        }
      }
    }
  }
 
</style>
